// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import store from './store'
// import axios from 'axios'
import axios from '@/plugins/axios';
import VueAxios from 'vue-axios'
import VueSocketIO from 'vue-socket.io'
import "prismjs"
import "prismjs/themes/prism-tomorrow.css"
// import "vue-prism-editor/dist/VuePrismEditor.css"
//vue-prism-editor dependency
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import FlagIcon from 'vue-flag-icon'
import SocketIO from 'socket.io-client';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueCookies from 'vue-cookies';
import Vuelidate from 'vuelidate';
import { i18n } from './plugins/i18n.js'
import AOS from 'aos'
import 'aos/dist/aos.css'

// import VueAnalytics from 'vue-analytics';

Vue.use(VueCookies)
Vue.use(require('vue-cookies'))
Vue.use(FlagIcon);
Vue.use(Vuelidate);
Vue.use(Vuetify)
Vue.use(VueAxios, axios)

AOS.init();

// const isPROD = process.env.NODE_ENV === 'production'

// Vue.use(VueAnalytics, {
//   id: 'UA-154112742-1',
//   router,
//   debug:{
//     enabled: !isPROD,
//     sendHitTask: isPROD
//   }
// });
// axios.defaults.withCredentials = false

const opts = {
    iconfont: 'md',
};
Vue.use(new VueSocketIO({
  debug: false,
  // connection: SocketIO('https://devinet-etax.one.th', { secure: true,
  // rejectUnauthorized: false, transports: ['websocket'], path: "/chat/socket.io/"} ),
  options: { secure: true, rejectUnauthorized: false, transports: ['websocket'], rememberTransport: false, path: "/serviceportalsio/socket.io" },
  connection: 'https://devinet-etax.one.th',
}))


Vue.$cookies.config('23h','/portal','',true,'Lax')
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  vuetify: new Vuetify(opts),
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js